const STORAGE_KEYS = {
    COOKIE_NOTIFICATION: 'cookieNotification',
    ITEMS_CLICK: 'items-click',
    ITEMS_IN_VIEWPORT: 'items-in-viewport',
    SAVE_SEARCH_HINT: 'save-search-tooltip',
    SEARCH_RECENT: 'search-recent',
    SELLING_DONT_ASK_FOR_SCHENKER_PRINTER: 'dontAskForSchenkerPrinter',
    WEB_PUSH_ACCEPTED: 'web_push_accepted',
    // State caches
    CACHE_MESSAGING_BADGES: 'cache.messagingBadges',
    CACHE_RECENTLY_VIEWED_ITEMS: 'cache.recentlyViewedItems',
    CACHE_SYSTEM_MESSAGES: 'cache.systemMessages'
};

const STORAGE_VALUES = {
    SAVE_SEARCH_HINT_CLICKED: 'CLOSE_CLICKED'
};

export { STORAGE_KEYS, STORAGE_VALUES };
